<template>
  <div>
    <div v-if="openModal">
      <ModalRegistration 
        @setCloseOpenModal="setOpenModal"
      />
    </div>
    
    <Loading v-if="loading" />
    <section v-else class="s-abrir-conta page-login">
      <div class="container-new">
        <LoginBanner />

        <FormNewLogin
          @userData="getUserData"
          @facebook="facebookLogin"
          @gmail="googleLogin"
          @setOpenModal="setOpenModal"
        />
      </div>
    </section>

    <FooterNewLogin />
  </div>
</template>

<script>
import axios from "axios";
import SessionManager from "../utils/session-manager";
import FooterNewLogin from "@/components/FooterNewLogin";
import FormNewLogin from "@/components/FormNewLogin";
import LoginBanner from "@/components/LoginBanner";
import Loading from '@/components/Loading';
import ModalRegistration from '@/components/NewModal/ModalRegistration'


export default {
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
      keepLogged: false,
      loading: true,
      openModal: false
    };
  },
  components: {
    FooterNewLogin,
    FormNewLogin,
    LoginBanner,
    Loading,
    ModalRegistration
  },
  methods: {
    getUserData(payload) {
      this.user.email = payload.email;
      this.user.password = payload.password;
      this.$store
        .dispatch("login", {
          email: this.user.email,
          password: this.user.password,
          keepLogged: true,
        })
        .then((resp) => {
          var urlParams = "";
          sessionStorage.removeItem("redirectINV");
          this.$ga.set({ userId: this.email });

          for (var key in this.$route.query) {
            if (this.$route.query.hasOwnProperty(key)) {
              if (key == "redirected_from") urlParams = this.$route.query[key];
              else
                urlParams =
                  urlParams + "&" + key + "=" + this.$route.query[key];
            }
          }

          if (
            this.$route.query.loansId !== undefined &&
            this.$route.query.loansId !== "" &&
            this.$route.query.loadnId !== null
          ) {
            this.$router.push(
              `/informacoes-adicionais/emprestimo-coletivo/${
                this.$route.query.loansId
              }`
            );
          } else if (urlParams != "") {
            this.$router.push(urlParams);
          } else {
            this.$router.push("/");
          }
        })
        .catch((error) => {
          if (error.response.data.Msg) {
            this.$Notify.error(error.response.data.Msg);
          } else {
            this.$Notify.error(
              "Tivemos um erro inesperado, tente novamente mais tarde"
            );
          }
        });
    },
    facebookLogin() {
      let scope = this
      FB.login(function(response) {
        if (response.status === 'connected') {
          scope.$store.dispatch('socialNetworkLogin', {provider:'facebook', receivedData:response.authResponse.accessToken, errorMessage: scope.$Notify.error})
          var urlParams = "";
          sessionStorage.removeItem("redirectINV");

          for (var key in scope.$route.query) {
            if (scope.$route.query.hasOwnProperty(key)) {
              if (key == "redirected_from") urlParams = scope.$route.query[key];
              else
                urlParams =
                  urlParams + "&" + key + "=" + scope.$route.query[key];
            }
          }

          if (
            scope.$route.query.loansId !== undefined &&
            scope.$route.query.loansId !== "" &&
            scope.$route.query.loadnId !== null
          ) {
            scope.$router.push(
              `/informacoes-adicionais/emprestimo-coletivo/${
                scope.$route.query.loansId
              }`
            );
          } else if (urlParams != "") {
            scope.$router.push(urlParams);
          } else {
            scope.$router.push("/");
          }
        } else {
          console.log("Não Loggado")
          if (error) {
            scope.$Notify.error(error);
          } else {
            scope.$Notify.error(
              "Tivemos um erro inesperado, tente novamente mais tarde"
            );
          }
        }
      }, {scope: 'public_profile,email'});
    },
    googleLogin() {
      const scope = this;
      this.$gAuth.signIn()
      .then(GoogleUser => {
        scope.$store.dispatch('socialNetworkLogin', { 
          provider:'google', 
          receivedData: GoogleUser.Zi.access_token, 
          errorMessage: scope.$Notify.error
        })
        var urlParams = "";
        sessionStorage.removeItem("redirectINV");

        for (var key in scope.$route.query) {
          if (scope.$route.query.hasOwnProperty(key)) {
            if (key == "redirected_from") urlParams = scope.$route.query[key];
            else
              urlParams =
                urlParams + "&" + key + "=" + scope.$route.query[key];
          }
        }

        if (
          scope.$route.query.loansId !== undefined &&
          scope.$route.query.loansId !== "" &&
          scope.$route.query.loadnId !== null
        ) {
          scope.$router.push(
            `/informacoes-adicionais/emprestimo-coletivo/${
              scope.$route.query.loansId
            }`
          );
        } else if (urlParams != "") {
          scope.$router.push(urlParams);
        } else {
          scope.$router.push("/");
        }
      })
      .catch(error  => {
        console.log('Sign-in error', error);
        if (error) {
          scope.$Notify.error(error);
        } else {
          scope.$Notify.error(
            "Tivemos um erro inesperado, tente novamente mais tarde"
          );
        }
      })
    },
    async login(event) {
      event.preventDefault();
    },
    fbLoadSDK(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },
    ggLoadSDK(d, s, id){
      var js, fjs = document.getElementsByTagName(s)[0];
      if (document.getElementById(id)) return;
      js = document.createElement(s); js.id = id;
      js.src = "https://apis.google.com/js/platform.js?onload=renderButton";
      fjs.parentNode.insertBefore(js, fjs);
    },
    fbStartServices(){
      FB.init({
        appId      : process.env.FB_ID,
        cookie     : true,
        xfbml      : true,
        version    : 'v4.0'
      });
    },
    ggStartServices(){
      let scope = this
      gapi.load('auth2', function() {
        gapi.auth2.init({
          client_id: process.env.GG_ID,
          cookiepolicy: 'single_host_origin',
          scope: 'profile'
        }).attachClickHandler(document.getElementById('gg-signin-button'), {},
          (googleUser) => {
            scope.$store.dispatch('socialNetworkLogin', {provider:'google', receivedData:googleUser.getAuthResponse().id_token, errorMessage: scope.$Notify.error})
          },
          (error) => {
            console.log('Sign-in error', error);
          }
        );
      });
    },

    setOpenModal() {
      this.openModal ?
      this.openModal= false :
      this.openModal= true
    }
  },
  created() {
    this.user.email = "";
    this.user.password = "";
    this.fbLoadSDK(document, 'script', 'facebook-jssdk')
    this.ggLoadSDK(document, 'script', 'google-jssdk')
    setTimeout(() => { 
      this.fbStartServices()
      this.ggStartServices()
      this.loading = false
    }, 3000);
  },
};
</script>

<style lang="scss" scoped>
$verde: #41d3bd;
$azul: #21247f;
$azul-sec: #3b46c4;
$branco: #ffffff;
$cinza-claro: #e9eafa;
$cinza-medio: #818495;
$cinza-escuro: #2c3236;

* {
  list-style: none;
  text-decoration: none;
  margin: 0;
  padding: 0;
  text-align: left;
  border: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  font-size: 1rem;
  line-height: 170%;
  letter-spacing: 0.01em;
  color: $cinza-medio;
}

body,
button,
input,
a,
h1,
span,
p {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
}

img {
  display: block;
  max-width: 100%;
}

.s-abrir-conta {
  padding-top: 65px;
  padding-bottom: 115px;
  border-bottom: 2px solid #81849533;

  .container-new {
    display: flex;
    justify-content: space-between;
    position: relative;
  }

  &.page-login {
    padding-bottom: 190px;
  }

  @media (max-width: 1050px) {
    padding-top: 140px;
    border-bottom: none;
    .container-new {
      justify-content: center;
      align-items: center;
      width: 100%;
    }
  }

  @media (max-width: 560px) {
    padding-bottom: 112px !important;
  }
}
.s-principal {
  margin-top: 90px;
  padding-top: 35px;
  padding-bottom: 82px;
  .container-new {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }

  @media (max-width: 768px) {
    padding-top: 50px;
    .container-new {
      flex-direction: column;
      justify-content: center;
    }
  }
}

.container-new {
  width: 1243px;
  padding: 0 15px;
  margin: 0 auto;
  @media (max-width: 1200px) {
    width: 100%;
    padding: 0px 24px;
    justify-content: center !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/NewLogin.vue